export class CounterStorage {
    public static counter: PIXI.Text;
}